import React, { useEffect, useRef } from 'react';
import { Link } from '@components/Link';

const ScrollTo = () => {
  const ref = useRef();

  useEffect(() => {
    window.scrollTo(0, ref?.current?.offsetTop || 0);
  }, []);

  return <Link ref={ref} />;
};

export default ScrollTo;
